import React, { Component } from "react";
import Aux from "../../hoc/Aux/Aux";
import Greeting from "../../components/UserFeed/Greeting/Greeting";
import Activities from "../../components/UserFeed/Activities/Activities";
import { getLogin, saveLogin } from "../../auth";
import { notify } from "../../components/Notify/Notify";
import Reminders from "../../components/UserFeed/Reminders/Reminders";
import DocumentView from "../../components/DocumentView/DocumentView";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../common/UserDataReducer";
import { gql } from "@apollo/client";
import { apolloClient } from "../../";

// Styles
import "./Feed.scss";

export const getDocument = async (documentId) => {
  const variables = {
    documentId: documentId,
  };
  try {
    const result = await apolloClient.query({
      query: gql`
        query document($documentId: UUID!) {
          document(documentId: $documentId) {
            id
            title
            fileUrl
            isArchive
            folder {
              id
              parentFolder {
                id
              }
            }
            documentType {
              id
              title
            }
            status {
              id
              name
            }
            modifiedBy {
              email
              firstName
              lastName
              profile {
                image
                role {
                  id
                  name
                }
              }
            }
            createdBy {
              email
              firstName
              lastName
              profile {
                image
                role {
                  id
                  name
                }
              }
            }
            modifiedTs
            abstractJson
            sharedDocument {
              id
              user {
                id
                email
                username
                firstName
                lastName
                profile {
                  image
                  role {
                    id
                    name
                  }
                }
              }
              userRole {
                id
                name
              }
            }
          }
        }
      `,
      variables: variables,
    });
    let document = result.data.document[0];
    if (document) {
      document = { ...document, abstractJson: JSON.parse(document.abstractJson) };
      return document;
    } else {
      const title = "Error";
      const detail = "Document not available";
      const type = "error";
      notify(title, detail, type);
    }
  } catch (e) {
    const title = "Error";
    const detail = e.message;
    const type = "error";
    notify(title, detail, type);
  }
};
class Feed extends Component {
  state = {
    showDocumentDetailModal: false,
    documentDetailModalInfo: {},
    isCommentActive: false
  };

  
  componentDidMount() {
    // Login success toastor
    if (!getLogin("login")) {
      const title = "Success";
      const detail = "User logged in successfully!";
      const type = "success";
      notify(title, detail, type);

      //set login true
      saveLogin("login", true);
    }
  }

  handleDocumentView = (document, isCommentActive = false) => {
    let documentFile = document.fileUrl;
    let documentPath = document.isArchive
      ? `/archives/${document.folder.parentFolder.id}/${document.folder.id}`
      : `/files/${document.folder.parentFolder.id}/${document.folder.id}`;

    this.setState({
      showDocumentDetailModal: true,
      documentDetailModalInfo: {
        title: document.title,
        fileUrl: document.fileUrl,
        documentObj: document,
        viewOnly: true,
        documentFile,
        documentPath,
      },
      isCommentActive: isCommentActive
    });
  };

  render() {
    return (
      <>
        <Aux>
          <div className="feed-wraper container-fluid" id="style-scroll">
            <div className="row">
              <div className="col-md-5 reminder-section">
                {Object.keys(this.props.currentUserInfo).length > 0 ? (
                  <Greeting {...{ firstName: this.props.currentUserInfo.firstName }} />
                ) : null}

                <Reminders handleDocumentView={this.handleDocumentView} />
              </div>
              <div className="col-md-7 activity-section">
                <Activities handleDocumentView={this.handleDocumentView} currentUserInfo={this.props.currentUserInfo} />
              </div>
            </div>
          </div>
          <DocumentView
            calendarView={true}
            showModal={this.state.showDocumentDetailModal}
            handleClose={(shouldReLoadData = false) => {
              this.setState({ showDocumentDetailModal: false });
            }}
            {...this.state.documentDetailModalInfo}
            userRoleId={this.props.userRoleId}
            currentUserInfo={this.props.currentUserInfo}
            isCommentActive={this.state.isCommentActive}
          />
        </Aux>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Feed);
